<app-newsletter-options [key]="key"></app-newsletter-options>
